/**
 * useQueueClientOptions — client + brand options for the queue-join identity
 * picker (CU-86cb7ewja), shared by the offer-draft availability tab, the
 * inventory catalog, and the media-unit detail calendar so each route
 * doesn't repeat the same normalize+map step. Neutral home (CU-86cbek5j5
 * extraction) since features/reservations itself never consumes this — the
 * real consumers (features/offers, routes/media-units) previously imported
 * it out of features/reservations/hooks, which is forbidden
 * (WEB_ARCHITECTURE.md:36).
 */
import { useMemo } from 'react';
import { normalizeClientList, useClientsList } from '../../clients/client-queries';
import type { QueueJoinClientOption } from './queue-join-types';

export function useQueueClientOptions(): QueueJoinClientOption[] {
  const clientsQuery = useClientsList();
  return useMemo(
    () =>
      normalizeClientList(clientsQuery.data).map((client) => ({
        value: String(client.id),
        label: client.name,
        brands: client.brands,
      })),
    [clientsQuery.data],
  );
}
